import './CryoStorage.css';

const CryoStorage = () => {
  return (
    <>
      <h1 className="coach-title">Coming soon</h1>
    </>
  );
};

export default CryoStorage;
